import React from 'react'

import { Formik } from 'formik'
import Yup from '_zari/validation/_yup'

import { Alert, Modal, Col, Row, Form, Button } from '_zari/core'

import { KeyEventUtil } from 'utils'

import * as AsientoContableCrud from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  numeroDocumento: Yup.string().required(),
  serieDocumento: Yup.string().required(),
  tipoDocumento: Yup.string().required()
})

const InformacionNotaCredDebModal = ({ show, handleClose, mainFormData, submitFunction }) => {
  const [buscando, setBuscando] = React.useState(false)
  const [flagNoEncontrado, setFlagNoEncontrado] = React.useState(null)

  const clickBuscar = React.useCallback(
    (values, setFieldValue) => {
      setBuscando(true)
      setFlagNoEncontrado(null)

      AsientoContableCrud.buscarExistentePorSerieNumero({
        origen: mainFormData.origen,
        idSocio: mainFormData._idSocio,
        numeroDocumento: values.numeroDocumentoBusqueda,
        serieDocumento: values.serieDocumentoBusqueda,
        tipoDocumento: values.tipoDocumentoBusqueda
      })
        .then(({ data }) => {
          if (data) {
            setFlagNoEncontrado(false)
            setFieldValue('_idDocumento', data._id)
            setFieldValue('numeroDocumento', data.numeroDocumento)
            setFieldValue('serieDocumento', data.serieDocumento)
            setFieldValue('tipoDocumento', data.tipoDocumento)
            setFieldValue('fechaDocumento', data.fechaEmision)
            KeyEventUtil.leaveOnKeyEvent('button-infonota-continuar')
          } else {
            setFlagNoEncontrado(true)
            setFieldValue('numeroDocumento', values.numeroDocumentoBusqueda)
            setFieldValue('serieDocumento', values.serieDocumentoBusqueda)
            setFieldValue('tipoDocumento', values.tipoDocumentoBusqueda)
          }
        })
        .finally(() => {
          setBuscando(false)
        })
    },
    [mainFormData]
  )

  const onSubmit = React.useCallback(
    submitData => {
      submitFunction({
        ...mainFormData,
        documentoModificado: {
          ...submitData,
          numeroDocumento: parseFloat(submitData.numeroDocumento)
        }
      })
    },
    [mainFormData, submitFunction]
  )

  const formInitialValues = React.useMemo(() => {
    return {
      _idDocumento: '',
      numeroDocumento: '',
      serieDocumento: '',
      numeroDocumentoBusqueda: '',
      serieDocumentoBusqueda: '',
      tipoDocumento: '',
      tipoDocumentoBusqueda: '',
      fechaDocumento: ''
    }
  }, [])

  return (
    <Modal show={show} onHide={handleClose} centered size='sm'>
      <Modal.Header>
        <Modal.Title>RELACIONADO DE NOTA</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={formInitialValues}
        validationSchema={ValidationSchema}
        onSubmit={onSubmit}
      >
        {({ errors, touched, isSubmitting, values, setFieldValue, handleSubmit }) => (
          <>
            <Modal.Body className='zari-slim-form'>
              <Row>
                <Col md={3}>
                  <FormGroups.SerieDocumentoBusquedaFormGroup
                    iError={errors.serieDocumentoBusqueda}
                    iTouched={errors.serieDocumentoBusqueda}
                    fIsSubmitting={isSubmitting || buscando}
                    setFieldValue={setFieldValue}
                  />
                </Col>
                <Col md={4}>
                  <FormGroups.NumeroDocumentoBusquedaFormGroup
                    iError={errors.numeroDocumentoBusqueda}
                    iTouched={touched.numeroDocumentoBusqueda}
                    fIsSubmitting={isSubmitting || buscando}
                  />
                </Col>
                <Col md={5}>
                  <FormGroups.TipoDocumentoBusquedaFormGroup
                    iError={errors.tipoDocumentoBusqueda}
                    iTouched={touched.tipoDocumentoBusqueda}
                    fIsSubmitting={isSubmitting || buscando}
                  />
                </Col>
                <Col md={12}>
                  <Form.Group>
                    <Col md={12}>
                      <Button
                        id='button-infonota-buscar'
                        block
                        disabled={buscando}
                        onClick={() => clickBuscar(values, setFieldValue)}
                      >
                        Buscar
                      </Button>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              {flagNoEncontrado && (
                <Row>
                  <Col md={12}>
                    <Alert color='warning'>
                      Documento no encontrado. Continuará con el modo manual.
                    </Alert>
                  </Col>
                </Row>
              )}
              {flagNoEncontrado !== null && (
                <>
                  <FormGroups.SerieDocumentoFormGroup
                    iError={errors.serieDocumento}
                    iTouched={errors.serieDocumento}
                    fIsSubmitting={isSubmitting}
                    setFieldValue={setFieldValue}
                  />
                  <FormGroups.NumeroDocumentoFormGroup
                    iError={errors.numeroDocumento}
                    iTouched={touched.numeroDocumento}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.TipoDocumentoFormGroup
                    iError={errors.tipoDocumento}
                    iTouched={touched.tipoDocumento}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.FechaDocumentoFormGroup
                    iError={errors.fechaDocumento}
                    iTouched={touched.fechaDocumento}
                    fIsSubmitting={isSubmitting}
                  />
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button id='button-infonota-continuar' disabled={isSubmitting} onClick={handleSubmit}>
                Continuar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(InformacionNotaCredDebModal)
